<template>
  <div class="Bgc-white">
    <Header v-if="banHeader" />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-3">
            <h4>{{$t('language.posadasCorporate.terminosCondiciones.terminosCondiciones')}}</h4>
          </div>

          <div class="col-12">
            <p class="title">{{$t('language.posadasCorporate.terminosCondiciones.title1')}} </p>
            <p>{{$t('language.posadasCorporate.terminosCondiciones.text1')}}</p>
          </div>

          <div class="col-12">
            <p class="title">{{$t('language.posadasCorporate.terminosCondiciones.title2')}}</p>
            <p>{{$t('language.posadasCorporate.terminosCondiciones.text2').split('#').join('"')}}
              <span class="b">{{$t('language.posadasCorporate.terminosCondiciones.text3')}}</span>{{$t('language.posadasCorporate.terminosCondiciones.text4')}}
            </p>
            <ol class="custom-ol">
              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title3')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text5')}}
                <span class="b">{{$t('language.posadasCorporate.terminosCondiciones.text6')}}</span>
              </p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text7')}}</p>

              <p>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text8')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text9')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text10')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text11')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text12')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text13')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text14')}}</b>
                <b>· {{$t('language.posadasCorporate.terminosCondiciones.text15')}}</b>
              </p>

              <p>{{$t('language.posadasCorporate.terminosCondiciones.text16')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text17')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text18')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text19')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text20')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title4')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text21')}}</p>
              <p>
                <span class="b">{{$t('language.posadasCorporate.terminosCondiciones.text22').split('#').join('"')}}</span>
              </p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text23')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title5')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text24')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text25')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text26')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title6')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text27')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text28')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text29')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text30').split('#').join('"')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title7')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text31')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text32')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title8')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text33')}}
              </p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text34')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title9')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text35')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title10')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text36')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title11')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text37')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title12')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text38')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title13')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text39')}}</p>

              <li class="title mb-2">{{$t('language.posadasCorporate.terminosCondiciones.title14')}}</li>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text40')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text41')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text42')}}</p>
              <p>{{$t('language.posadasCorporate.terminosCondiciones.text43')}}</p>
            </ol>
          </div>

          <div class="col-12 col-md-4 mt-2 mb-5 ml-auto">
            <button class="mt-3 primary-button" @click="back">{{$t('language.posadasCorporate.terminosCondiciones.entendido')}}</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import SecureLS from 'secure-ls';

  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        ls: new SecureLS({ encodingType: "aes" }),
        banHeader: false
      }
    },
    created(){
      var nameComponent = window.location.pathname;
      if (this.ls.get('Token')) {
        this.banHeader = true;
      }
    },
    methods:{
      back(){
        if (this.ls.get('Token')) {
          this.$router.push({ name: 'Reservaciones'});
        }else{
          this.$router.go(-1);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .custom-ol {
    margin-left: 35px;
    @media(max-width: 550px) {
      margin-left: 20px;
    }
  }
</style>